const gerarCodigoVerificacao = () => {
    const codigo = Math.floor(100000 + Math.random() * 900000);
    document.getElementById('form-field-codigo').value = codigo;
    return codigo;
}

export {gerarCodigoVerificacao}
